import {createRouter, createWebHashHistory} from 'vue-router'

const home = () => import('@/view/home.vue')
const recruitStudents = () => import('@/view/recruitStudents.vue') //招生简章
const registration = () => import('@/view/registrationProcess.vue') // 报考流程
const valueGiving = () => import('@/view/valueGiving.vue') // 超值赠送
const cooperation = () => import('@/view/cooperation.vue') // 战略合作
const toSignUp = () => import('@/view/toSignUp.vue') // 报名入口
const classAdmin = () => import('@/view/classAdmin.vue') // 听课入口
const loginPage = () => import('@/view/loginPage.vue') // 登录页
const aboutUs = () => import('@/view/aboutUs.vue') // 走进三君
const userIndex = () => import('@/view/userIndex.vue') // 个人主页
const workTogether = () => import('@/view/workTogether.vue') // 合作平台
const agreementBook = () => import('@/view/agreementBook.vue') // 志愿者协议
const studentGroup = () => import('@/view/studentGroup.vue') // 学员课程管理
const volunteerGroup = () => import('@/view/volunteerGroup.vue') // 志愿者管理
const forgetPassword = () => import('@/view/forgetPassword.vue') // 修改密码
const userGroup = () => import('@/view/userGroup.vue') //  学员管理
const VolTab = () => import('@/view/VolTab.vue') //  志愿者
const Contract = () => import('@/view/contract.vue') //  合同协议
const KeyanList = () => import('@/view/KeyanList.vue') //  合同协议
const KeyanContent = () => import('@/view/KeyanContent.vue') //  合同协议
const XinwenList = () => import('@/view/XinwenList.vue') //  合同协议
const XinwenContent = () => import('@/view/XinwenContent.vue') //  合同协议

const peixuntaocan = () => import('@/view/peixuntaocan.vue') //  培训套餐


const routes = [
    {
        path: '/',
        name: 'home',
        component: home
    }, {
        path: '/peixuntaocan',
        name: 'peixuntaocan',
        component: peixuntaocan
    }, {
        path: '/recruitStudents',
        name: 'recruitStudents',
        component: recruitStudents
    }, {
        path: '/registration',
        name: 'registration',
        component: registration
    }, {
        path: '/toSignUp',
        name: 'toSignUp',
        component: toSignUp
    }, {
        path: '/classAdmin/',
        name: 'classAdmin',
        component: classAdmin
    }, {
        path: '/loginPage',
        name: 'loginPage',
        component: loginPage
    }, {
        path: '/aboutUs',
        name: 'aboutUs',
        component: aboutUs
    }, {
        path: '/userIndex',
        name: 'userIndex',
        component: userIndex
    }, {
        path: '/workTogether/:id',
        name: 'workTogether',
        component: workTogether
    },  {
        path: '/agreementBook',
        name: 'agreementBook',
        component: agreementBook
    }, {
        path: '/studentGroup',
        name: 'studentGroup',
        component: studentGroup
    }, {
        path: '/volunteerGroup',
        name: 'volunteerGroup',
        component: volunteerGroup
    }, {
        path: '/forgetPassword',
        name: 'forgetPassword',
        component: forgetPassword
    }, {
        path: '/userGroup',
        name: 'userGroup',
        component: userGroup
    }, {
        path: '/VolTab',
        name: 'VolTab',
        component: VolTab
    }, {
        path: '/valueGiving',
        name: 'valueGiving',
        component: valueGiving
    }, {
        path: '/cooperation',
        name: 'cooperation',
        component: cooperation
    }, {
        path: '/Contract',
        name: 'Contract',
        component: Contract
    }, {
        path: '/KeyanList/:id',
        name: 'KeyanList',
        component: KeyanList
    },  {
        path: '/KeyanContent/:id',
        name: 'KeyanContent',
        component: KeyanContent
    },{
        path: '/XinwenList/:id',
        name: 'XinwenList',
        component: XinwenList
    },  {
        path: '/XinwenContent/:id',
        name: 'XinwenContent',
        component: XinwenContent
    }
]

const router = createRouter({
    history: createWebHashHistory(),  //history
    routes
})

export default router
